module.exports = __webpack_public_path__ + "static/media/md-male.6cb30eee.svg";